import { useEffect, useMemo } from 'react';
import { skipToken, useQuery } from '@apollo/client/react';

import {
    ISkillListItemFragment,
    ISkillsQueryVariables,
    SkillsDocument,
} from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

export const useSkillDrawerList = (queryVariables?: ISkillsQueryVariables) => {
    const { showApolloError } = useApolloError();

    const { data, loading, error } = useQuery(
        SkillsDocument,
        queryVariables
            ? {
                  variables: queryVariables,
                  notifyOnNetworkStatusChange: true,
              }
            : skipToken
    );

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    const skillsObject = data?.skills;
    const skillsCount = skillsObject?.count;
    const skills = useMemo(
        () =>
            (skillsObject?.edges
                .map((edge) => edge?.node || null)
                .filter(Boolean) as ISkillListItemFragment[]) || [],
        [skillsObject?.edges]
    );

    return {
        skills,
        skillsCount,
        loading,
    };
};
